import { Box } from 'components/layout';
import { Header } from 'components/Header';

export const Dashboard = () => {
    return (
      <Box>
        <Header />
        Dashboard Protected Route (logged in)
      </Box>
    );
}